import React, { createContext, useReducer } from "react";
import { overviewReducer } from "../reducers/overviewReducer";

export const OverviewContext = createContext();

const OverviewContextProvider = (props) => {
  const [overview, dispatch] = useReducer(overviewReducer, {
    objects: 0,
    notifications: 0,
    devices: 0,
    prevObjects: 0,
    prevNotification: 0,
    prevDevices: 0,
  });

  return (
    <OverviewContext.Provider value={{ overview, dispatch }}>
      {props.children}
    </OverviewContext.Provider>
  );
};

export default OverviewContextProvider;
